import React from "react";
import Alert from "~/assets/js/components/Alert";
import Button from "~/assets/js/components/Button";
import PropTypes from "prop-types";
import i18next from "i18next";

export const ProductDetailsErrorAlert = ({
    onClose,
    onRedirect,
    image,
    category,
    error,
}) => {
    return (
        <Alert
            header={i18next.t(
                `productDetails.alert.${category}.${error}.title`
            )}
            text={i18next.t(`productDetails.alert.${category}.${error}.text`)}
            image={image}
            buttons={
                <>
                    <Button
                        label={i18next.t(
                            `productDetails.alert.${category}.goToConfigurator`
                        )}
                        onClick={onRedirect}
                    />
                    <Button
                        variant="secondary"
                        label={i18next.t("productDetails.alert.close")}
                        onClick={onClose}
                    />
                </>
            }
            onClose={onClose}
        />
    );
};

export const NoDressingSelectedAlert = ({
    image,
    onClose,
    error,
    onRedirect,
}) => {
    return (
        <Alert
            image={image}
            header={i18next.t(`productDetails.alert.other.${error}.title`)}
            onClose={onClose}
            text={i18next.t(`productDetails.alert.other.${error}.text`)}
            buttons={
                <>
                    <Button
                        label={i18next.t(
                            `productDetails.alert.other.${error}.wantDressing`
                        )}
                        onClick={onRedirect}
                    />
                    <Button
                        variant="secondary"
                        label={i18next.t(
                            `productDetails.alert.other.${error}.noDressingWanted`
                        )}
                        onClick={onClose}
                    />
                </>
            }
        />
    );
};

export const ProductOutOfStockAlert = ({ onClose, image }) => {
    return (
        <Alert
            image={image}
            header={i18next.t(`productDetails.alert.other.outOfStock.title`)}
            onClose={onClose}
            text={i18next.t(`productDetails.alert.other.outOfStock.text`)}
        />
    );
};

export const AddToBasketErrorAlert = ({ onClose, image }) => {
    return (
        <Alert
            image={image}
            header={i18next.t("productDetails.alert.basketError.title")}
            onClose={onClose}
            text={i18next.t("productDetails.alert.basketError.text")}
        />
    );
};

const AlertProps = {
    onClose: PropTypes.func,
    onRedirect: PropTypes.func,
    error: PropTypes.string,
    image: PropTypes.string,
    category: PropTypes.string,
};

NoDressingSelectedAlert.propTypes = AlertProps;
ProductDetailsErrorAlert.propTypes = AlertProps;
AddToBasketErrorAlert.propTypes = AlertProps;
ProductOutOfStockAlert.propTypes = AlertProps;
